

export const teamResumeStatsActions = {
    FETCH_TEAM_RESUME_STATS_FAILED: 'FETCH_TEAM_RESUME_STATS_FAILED',
    FETCH_TEAM_RESUME_STATS_SUCCESS: 'FETCH_TEAM_RESUME_STATS_SUCCESS',
    FETCH_TEAM_RESUME_STATS_PENDING: 'FETCH_TEAM_RESUME_STATS_PENDING',
    LOAD_TEAM_RESUME_STATS: 'LOAD_TEAM_RESUME_STATS',

    fetchTeamResumeStatsFailed: (error, team_id) => ({
        type: teamResumeStatsActions.FETCH_TEAM_RESUME_STATS_FAILED,
        payload: {
            data: error,
            team_id
        }
    }),

    fetchTeamResumeStatsSuccess: (team_id, data) => ({
        type: teamResumeStatsActions.FETCH_TEAM_RESUME_STATS_SUCCESS,
        payload: {
            data,
            team_id
        }
    }),

    fetchTeamResumeStatsPending: team_id => {
        return ({
            type: teamResumeStatsActions.FETCH_TEAM_RESUME_STATS_PENDING,
            payload: {
                team_id
            }
        })
    },

    loadTeamResumeStats: team_id => ({
        type: teamResumeStatsActions.LOAD_TEAM_RESUME_STATS,
        payload: {
            team_id
        }
    })
};

export const teamResumeStatsRequestActions = {
    failed: teamResumeStatsActions.fetchTeamResumeStatsFailed,
    success: teamResumeStatsActions.fetchTeamResumeStatsSuccess,
    pending: teamResumeStatsActions.fetchTeamResumeStatsPending
};
